import useBootstrapData from '@/hooks/useBootstrapData'
import { Box, Heading, Hide } from 'pcln-design-system'
import DealCarouselLoader from './DealCarouselLoader'
import PackagesDealCarousel from './PackageDealCarousel'
import useFetchPackages from './useFetchPackages'

interface PackagesCarouselProps {
  heading?: string
  headingMobile?: string
}

export default function PackagesCarousel({
  heading = "Don't miss these package deals",
  headingMobile = "Don't miss these deals",
}: PackagesCarouselProps) {
  const {
    locale: { longitude, latitude },
  } = useBootstrapData()
  const { deals, isLoading } = useFetchPackages({
    latitude,
    longitude,
  })

  if (isLoading) {
    return <DealCarouselLoader />
  }

  return deals.length > 0 ? (
    <Box>
      <Heading ml={2} pb={20} fontSize={4} fontWeight='bold' m={0} color='text.heading' textStyle='heading2'>
        <Hide xs>{heading}</Hide>
        <Hide sm md lg xl xxl>
          {headingMobile}
        </Hide>
      </Heading>
      <PackagesDealCarousel deals={deals} />
    </Box>
  ) : null
}
